const PADDLE_TRANSACTION_TYPE = {
  DEFAULT_PAYMENT: "default-payment",
  DOMAIN_PURCHASE: "domain-purchase",
  INVOICE_PAYMENT: "invoice-payment",
  PAYMENT_METHOD_UPDATE: "payment-method-update",
  SUBSCRIPTION_PURCHASE: "subscription-purchase",
  SUBSCRIPTION_PURCHASE_WITH_UNPAID_OVERAGE: "subscription-purchase-with-unpaid-overage",
  UNPAID_TRANSACTION_PAYMENT: "unpaid-transaction-payment",
};

export default PADDLE_TRANSACTION_TYPE;
